import React, { useMemo } from "react";
import {Button, FormGroup, Table} from "react-bootstrap";
import moment from "moment";

export default ({eventPassword, streams, streamType}) => {
    const EpisodeRow = ({nameRu, timeStart, timeStop, connectionsCount, clientsCount, like, favorite}) => {
        return (
            <tr>
                <td>{nameRu}</td>
                <td>{moment.unix(timeStart).format('D MMMM, HH:mm')} - {moment.unix(timeStop).format('HH:mm')}</td>
                <td>{connectionsCount}</td>
                <td>{clientsCount}</td>
                <td>{like}</td>
                <td>{favorite}</td>
            </tr>
        );
    }

    const streamsSortedEpisodes = useMemo(() => {
        return streams.map(stream => ({
            ...stream,
            episodes: stream.episodes.slice().sort((a, b) => a.timeStart - b.timeStart),
        }));
    }, [streams]);

    return (
        <>
            {streamsSortedEpisodes.map((stream) => (
                <React.Fragment key={stream.id}>
                    <FormGroup style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button
                            href={`/api/cp/event/${eventPassword}/statistic/episodes.xlsx?type=${streamType}&streamId=${stream.id}`}
                            bsStyle="primary"
                            target="_blank"
                        >
                            Скачать Excel
                        </Button>
                    </FormGroup>
                    <Table>
                        <thead>
                        <tr>
                            <th>{stream.descriptionRu}</th>
                            <th style={{width: 200}}>Время</th>
                            <th style={{width: 100}}>Просмотры</th>
                            <th style={{width: 100}}>Зрителей</th>
                            <th style={{width: 60}}>Like</th>
                            <th style={{width: 60}}>Избранное</th>
                            {/*<th>Комментарии</th>*/}
                            {/*<th>Вопросы</th>*/}
                        </tr>
                        </thead>
                        <tbody>
                            {stream.episodes.map((episode) => (
                                <EpisodeRow key={episode.id} {...episode} />
                            ))}
                        </tbody>
                    </Table>
                </React.Fragment>
            ))}
        </>
    );
}
